<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="loading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span  class="title" >{{title}}</span>
  </span>
  <div v-html="email">
  </div>

  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button @click="closeDialog">{{$t('buttons.close')}}</el-button>
  </span>
  </el-dialog>
</template>
<script>

import axios from 'axios';


export default {
  name: 'EmailDeliveryPreview',
	props: {
		emailDeliveryId : Number,
    visible : Boolean
	},
  data() {
    return {
      loading:true,
      emailDelivery : null,
    };
  },components: {

  },
	methods: {
    closeDialog(){
      this.$emit('close');
    },
    open(){
      this.loading=true;

      return axios.get(process.env.VUE_APP_MAILER_HOSTNAME+":"+process.env.VUE_APP_MAILER_PORT+process.env.VUE_APP_MAILER_PATH+"/emails/"+this.emailDeliveryId)
        .then(results=>{
          this.emailDelivery = results.data;

        })
      this.loading=false;
    }
	},
	computed: {
    email(){
      if(this.emailDelivery!=null){
        return this.emailDelivery.email_content;
      }
      return "";
    },
    title(){
      if(this.emailDelivery!=null){
        return this.emailDelivery.subject;
      }
      return "";
    },

	},
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}


.formContainer{
    margin-left:30%;
    width:50%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:20%;
      width:60%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:15%;
      width:70%;
    }
}

</style>
